export default __webpack_public_path__ + "static/media/answer-fail.6e166989.svg";